import { render } from "./CryptoTable.vue?vue&type=template&id=b01be160&scoped=true"
import script from "./CryptoTable.vue?vue&type=script&lang=js"
export * from "./CryptoTable.vue?vue&type=script&lang=js"

import "./CryptoTable.vue?vue&type=style&index=0&id=b01be160&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b01be160"]])

export default __exports__